<template>
  <div>
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand bg-white navbar-light border-bottom">
      <!-- Right navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#">
            <i class="fas fa-bars"></i>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <!-- Messages Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="fas fa-bell"></i>
            <span class="badge badge-danger navbar-badge">{{$root.notifiAmount}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <div v-if="$root.notifications!=''">
              <a v-for="notifi in $root.notifications" :key="notifi.index" href="#" @click="readNotifi(notifi.notifi_id)" class="dropdown-item">
                <!-- Message Start -->
                <div class="media">
                  <div class="media-body">
                    <h3 class="dropdown-item-title">
                      {{notifi.notifi_title}}
                      <span class="float-right text-sm text-danger">
                        <i class="fas fa-money-bill-wave"></i>
                      </span>
                    </h3>
                    <p class="text-10">{{notifi.notifi_name}}</p>
                    <p class="text-muted text-10">
                      <i class="fas fa-clock mr-1"></i> {{moment(notifi.created_at).locale('th').subtract('days').calendar()}}
                    </p>
                  </div>
                </div>
                <!-- Message End -->
              </a>
            </div>
            <div v-else>
              <a href="#" class="dropdown-item">
                <!-- Message Start -->
                <div class="media">
                  <div class="media-body">
                    <p class="text-10 text-center">ไม่มีการแจ้งเตือน</p>
                  </div>
                </div>
                <!-- Message End -->
              </a>
              <div class="dropdown-divider"></div>
            </div>
            <div class="dropdown-divider"></div>
          </div>
        </li>
      </ul>
    </nav>
    <!-- /.navbar -->

    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-dark-primary elevation-4">
      <!-- Brand Logo -->
      <a href="#" class="brand-link">
        <img
          src="../../dist/logo.png"
          alt="AdminLTE Logo"
          class="brand-image img-circle elevation-3"
          style="opacity: .8"
        >
        <span class="brand-text font-weight-light">BannKlong</span>
      </a>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <!-- Add icons to the links using the .nav-icon class
            with font-awesome or any other icon font library-->
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-tachometer-alt"></i>
                <p>
                  Dashboard
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item">
                  <router-link to="/pageHome" class="nav-link">
                    <i class="fas fa-circle-o nav-icon"></i>
                    <p>Dashboard</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link to="/pageOrders" class="nav-link">
                <i class="nav-icon fas fa-copy"></i>
                <p>
                  รายการสั่งซื้อ
                </p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/pagePayment" class="nav-link">
                <i class="nav-icon fab fa-btc"></i>
                <p>ชำระสินค้า</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/pageDelivery" class="nav-link">
                <i class="nav-icon fas fa-truck-moving"></i>
                <p>จัดส่งสินค้า</p>
              </router-link>
            </li>
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-window-restore"></i>
                <p>
                  รายงาน
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item">
                  <router-link to="/pageReportOrder" class="nav-link">
                    <i class="fas fa-circle-o nav-icon"></i>
                    <p>รายงานการสั่งซื้อ</p>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/pageReportBestSeller" class="nav-link">
                    <i class="fas fa-circle-o nav-icon"></i>
                    <p>รายงานสินค้าขายดี</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-header text-warning">Management <i class="fas fa-cogs"></i></li>
            <li class="nav-item">
              <router-link to="/pageCustomers" class="nav-link">
                <i class="nav-icon fas fa-users"></i>
                <p>
                  สมาชิก
                </p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/banners" class="nav-link">
                <i class="nav-icon fas fa-images"></i>
                <p>
                  แบนเนอร์
                </p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/pageProducts" class="nav-link">
                <i class="nav-icon fas fa-boxes"></i>
                <p>
                  สินค้า
                </p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/pageArticle" class="nav-link">
                <i class="nav-icon fas fa-scroll"></i>
                <p>
                  บทความ
                </p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/pageContact" class="nav-link">
                <i class="nav-icon fas fa-address-book"></i>
                <p>
                  ติดต่อเรา
                </p>
              </router-link>
            </li>
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-database"></i>
                <p>
                  ข้อมูลพื้นฐาน
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item">
                  <router-link to="/typeProduct" class="nav-link">
                    <i class="fas fa-boxes nav-icon"></i>
                    <p>ประเภทสินค้า</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link to="/administrator" class="nav-link">
                <i class="nav-icon fas fa-user-secret"></i>
                <p>ผู้ใช้งานระบบ</p>
              </router-link>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" v-on:click="logout()">
                <i class="nav-icon fas fa-sign-out-alt text-danger"></i>
                <p class="text">Logout</p>
              </a>
            </li>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>
  </div>
</template>

<script>
var moment = require('moment');
export default {
  data(){
    return {
      moment: moment,
    }
  },
  methods: {
    logout() {
      this.$root.actionLogout();
    },
    notification(){
      this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/notification')
      .then((response) =>{
        console.log(response.data)
        this.$root.notifications = response.data
        this.$root.notifiAmount = response.data.length
      })
    },
    readNotifi(id){
      this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/readNotifi', {id:id})
      .then((response) => {
        window.location.href = '/pagePayment'
      })
    }
  },
  created(){
    this.notification()
  }
};
</script>


// WEBPACK FOOTER //
// src/components/HeaderBack.vue